

import { AppTheme } from './material-ui/theme';
import { LogsProvider } from './provider/LogsContextProvider';
import { AppRouter } from './router/AppRouter';
//import { ThemeProvider } from '@mui/material';
//import { AppTheme } from './theme/AppTheme';

export const App = () => {
  return (
    <>
      <LogsProvider>

        <AppTheme>
          <AppRouter />
        </AppTheme>
        <div
          id="pingPosterContainer"
          style={{
            position: 'fixed',
            top: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            zIndex: 1400
          }}
        />
      </LogsProvider>
    </>
  )
}





